import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CompeticionFormComponent } from '../competicion-form/competicion-form.component';

import { TemporadaService } from '../../temporadas/services/temporada.service';
import { TemporadaViewModel } from '../../temporadas/models/temporada-view-model';

import { EquipoService } from '../../equipos/services/equipo.service';
import { EquipoViewModel } from '../../equipos/models/equipo-view-model';

import { CompeticionService } from '../services/competicion.service';
import { CompeticionViewModel } from '../models/competicion-view-model';

import { AngularFireAuth } from '@angular/fire/auth';
import { User } from '../../../autenticacion/models/user';

@Component({
    selector: 'app-competicion-list',
    templateUrl: './competicion-list.component.html',
    styleUrls: ['./competicion-list.component.scss']
})
export class CompeticionListComponent implements OnInit {

    user: User;
    editable : boolean = false;

    constructor(
        private temporadaService: TemporadaService, 
        private equipoService: EquipoService, 
        private competicionService: CompeticionService, 
        private modalService: NgbModal,
        private afAuth: AngularFireAuth) { }

    ngOnInit(): void {

        this.afAuth.user.subscribe(user => {
            if (user) {
                this.user = user;
                if (user.email == 'espirou79@gmail.com'){
                    this.editable = true;
                }
            }
        })
        
        this.loadTemporadas();
    }

    clickAddCompeticion() {
        const modal = this.modalService.open(CompeticionFormComponent);
        modal.result.then(
            this.handleModalCompeticionFormClose.bind(this),
            this.handleModalCompeticionFormClose.bind(this));
        modal.componentInstance.temporada = this.temporadaSel;
        modal.componentInstance.equipo = this.equipoSel;
    }

    handleModalCompeticionFormClose(response: any) {
        // is response an object?
        if (response === Object(response)) {
            if (response.editMode == 'C') {
                response.competicion.id = response.id;
                this.competiciones.unshift(response.competicion);
            } else if (response.editMode == 'M') {
                let index = this.competiciones.findIndex(value => value.id == response.id);
                this.competiciones[index] = response.competicion;
            } else if (response.editMode == 'D') {
                let index = this.competiciones.findIndex(value => value.id == response.id);
                this.competiciones.splice(index, 1);
            }
        }
    }

    competiciones: CompeticionViewModel[] = [];

    loadCompeticiones(temporadaId: string, equipoId:string) {
        this.competicionService.getCompeticiones(temporadaId, equipoId).subscribe(response => {
            this.competiciones = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const competicion: CompeticionViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    orden: data.orden,
                    codFmp: data.codFmp,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja,
                    temporadaId: temporadaId,
                    equipoId: equipoId
                };

                this.competiciones.push(competicion);
            });
        });
    }

    handleEditClick(competicion: CompeticionViewModel) {
        const modal = this.modalService.open(CompeticionFormComponent);
        modal.result.then(
            this.handleModalCompeticionFormClose.bind(this),
            this.handleModalCompeticionFormClose.bind(this)
        )
        modal.componentInstance.editMode = 'M';
        modal.componentInstance.temporada = this.temporadaSel;
        modal.componentInstance.equipo = this.equipoSel;
        modal.componentInstance.competicion = competicion;
    }

    temporadas: TemporadaViewModel[] = [];
    temporadaSel: TemporadaViewModel;

    loadTemporadas() {
        this.temporadaService.getTemporadas().subscribe(response => {
            this.temporadas = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const temporada: TemporadaViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    fechaInicio: data.fechaInicio,
                    fechaFin: data.fechaFin,
                    finalizada: data.finalizada,
                    codFmp: data.codFmp,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja
                };

                this.temporadas.push(temporada);

            });
            if (this.temporadas.length > 0) {
                this.temporadaSel = this.temporadas[0];
                this.loadEquipos(this.temporadaSel.id);
            }
        });
    }

    selectTemporadaChangeHandler(event: any) {
        let index = this.temporadas.findIndex(value => value.id == event.target.value);
        this.temporadaSel = this.temporadas[index];

        this.loadEquipos(this.temporadaSel.id);
    }

    equipos: EquipoViewModel[] = [];
    equipoSel: EquipoViewModel;

    loadEquipos(temporadaId: string) {
        this.equipoService.getEquipos(temporadaId).subscribe(response => {
            this.equipos = [];
            response.docs.forEach(value => {
                const data = value.data();
                const id = value.id;
                const equipo: EquipoViewModel = {
                    id: id,
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    categoriaId: data.categoriaId,
                    codFmp: data.codFmp,
                    orden: data.orden,
                    _fechaModificacion: data.fechaModificacion,
                    _userModificacion: data.userModificacion,
                    _lgBaja: data.lgBaja,
                    _fechaBaja: data.fechaBaja,
                    _userBaja: data.userBaja,
                    temporadaId: temporadaId
                };

                this.equipos.push(equipo);

            });
            if (this.equipos.length > 0) {
                this.equipoSel = this.equipos[0];
                this.loadCompeticiones(this.temporadaSel.id, this.equipoSel.id);
            }
        });
    }

    selectEquipoChangeHandler(event: any) {
        let index = this.equipos.findIndex(value => value.id == event.target.value);
        this.equipoSel = this.equipos[index];

        this.loadCompeticiones(this.equipoSel.temporadaId, this.equipoSel.id);
    }
}
